export enum UserSort {
	CREATION_TIME = 'CREATION_TIME',
	EMAIL_ADDRESS = 'EMAIL_ADDRESS',
	FIRST_NAME = 'FIRST_NAME',
	LAST_NAME = 'LAST_NAME',
	ROLE = 'ROLE',
}
